import { useState } from "react";
import { Volume2, VolumeX, Play, ChevronDown } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Slider } from "@/components/ui/slider";
import { SOUNDS, soundOn, setSoundOn, soundEnabled, setSoundEnabled, getVolume, setVolume, previewSound, unlockAudio } from "@/lib/celebrate";

function SoundRow({ id, label, disabled }) {
  const [on, setOn] = useState(soundEnabled(id));
  const toggle = (v) => { setOn(v); setSoundEnabled(id, v); if (v) previewSound(id); };
  return (
    <li className="flex items-center gap-3 py-2.5" data-testid={`sound-row-${id}`}>
      <button type="button" onClick={() => previewSound(id)} disabled={disabled} data-testid={`sound-play-${id}`} aria-label={`${label} anhören`}
        className="w-9 h-9 shrink-0 rounded-full bg-rose-50 text-rose-500 flex items-center justify-center hover:bg-rose-100 active:scale-95 transition-transform disabled:opacity-40"><Play className="w-4 h-4" fill="currentColor" /></button>
      <span className={`flex-1 min-w-0 text-sm font-semibold ${on ? "text-slate-800" : "text-slate-400"}`}>{label}</span>
      <Switch checked={on} onCheckedChange={toggle} disabled={disabled} data-testid={`sound-switch-${id}`} />
    </li>
  );
}

export function SoundSettings() {
  const [on, setOn] = useState(soundOn());
  const [vol, setVol] = useState(Math.round(getVolume() * 100));
  const [open, setOpen] = useState(false);
  const toggle = (v) => { setOn(v); setSoundOn(v); if (v) { unlockAudio(); previewSound("coin"); } };
  const changeVol = ([v]) => { setVol(v); setVolume(v / 100); };
  return (
    <div className="bg-white rounded-3xl p-6 border border-pink-100 space-y-5" data-testid="sound-toggle">
      <div className="flex items-start gap-4">
        <span className="w-10 h-10 shrink-0 rounded-2xl bg-amber-50 text-amber-500 flex items-center justify-center">{on ? <Volume2 className="w-5 h-5" /> : <VolumeX className="w-5 h-5" />}</span>
        <div className="flex-1 min-w-0">
          <p className="font-bold">Soundeffekte</p>
          <p className="text-sm text-slate-500">Lautstärke einstellen und einzelne Sounds an- oder ausschalten.</p>
        </div>
        <Switch checked={on} onCheckedChange={toggle} data-testid="sound-switch" />
      </div>
      <div className={`space-y-2 ${on ? "" : "opacity-50 pointer-events-none"}`}>
        <div className="flex items-center justify-between text-sm font-semibold"><span>Lautstärke</span><span className="tabular-nums text-rose-600" data-testid="sound-volume-value">{vol} %</span></div>
        <Slider value={[vol]} min={0} max={100} step={5} onValueChange={changeVol} onValueCommit={() => previewSound("coin")} data-testid="sound-volume" />
      </div>
      <button type="button" onClick={() => setOpen((o) => !o)} data-testid="sound-list-toggle" className="w-full flex items-center justify-between text-sm font-bold text-rose-600">
        Einzelne Sounds ({SOUNDS.length}) <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <ul className="divide-y divide-pink-50 -my-2" data-testid="sound-list">{SOUNDS.map(([id, label]) => <SoundRow key={id} id={id} label={label} disabled={!on} />)}</ul>}
    </div>
  );
}
